import axios from 'axios';
import * as config from '../../Config/api.js';
import prepareFinalPartnerFormData from '../../Helpers/buildPartnerFormData.js';
  

export const updateStepData = (stepIndex, data) => ({
    type: 'UPDATE_STEP_DATA',
    payload: { stepIndex, data }
  });

  // Função para buscar serviços
  export const retrieveCompanyServices = (props = {}) => {
    return (dispatch) => {
      const preparedData = {
        type: 'service'
      };
  
      axios({
        url: `${config.API_URL}/system/retrieveCompanyServices`,
        method: 'POST',
        data: preparedData,
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          const result = response.data;
          //console.log('[retrieveCompanyServices] Resultado:', result); // Debug
  
          if (!result || result.status !== true) {
            if (props.setError) {
              props.setError(result?.message || 'Erro ao consultar serviços.');
            }
            return;
          }
  
          dispatch({ type: 'SET_SERVICES_LIST', payload: result.data });
  
          if (props.setSuccess) {
            props.setSuccess(result.data);
          }
  
        })
        .catch((error) => {
          console.error('Erro ao buscar serviços:', error);
          if (props.setError) {
            props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
          }
        });
    };
  };
  
// Função para buscar descontos em opticas
  export const retrieveCompanyDiscounts = (props = {}) => {
    return (dispatch) => {
      const preparedData = {
        type: 'discount'
      };
  
      axios({
        url: `${config.API_URL}/system/retrieveCompanyServices`,
        method: 'POST',
        data: preparedData,
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          const result = response.data;
         // console.log('[retrieveCompanyDiscounts] Resultado:', result); // Debug
  
          if (!result || result.status !== true) {
            if (props.setError) {
              props.setError(result?.message || 'Erro ao consultar descontos.');
            }
            return;
          }
  
          dispatch({ type: 'SET_DISCOUNTS_LIST', payload: result.data });
  
          if (props.setSuccess) {
            props.setSuccess(result.data);
          }
  
        })
        .catch((error) => {
          console.error('Erro ao buscar serviços:', error);
          if (props.setError) {
            props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
          }
        });
    };
  };
  
  // Função para buscar subespecialidades
  export const retrieveCompanySpecialities = (props = {}) => {
    return (dispatch) => {
      const preparedData = {
        parent: 1
      };
  
      axios({
        url: `${config.API_URL}/system/retrieveCompanySpecialities`,
        method: 'POST',
        data: preparedData,
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          const result = response.data;
          console.log('[retrieveCompanySpecialities] Resultado:', result); // Debug
  
          if (!result || result.status !== true) {
            if (props.setError) {
              props.setError(result?.message || 'Erro ao consultar subespecialidades.');
            }
            return;
          }
  
          dispatch({ type: 'SET_SPECIALITIES_LIST', payload: result.data });
  
          if (props.setSuccess) {
            props.setSuccess(result.data);
          }
  
        })
        .catch((error) => {
          console.error('Erro ao buscar subespecialidades:', error);
          if (props.setError) {
            props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
          }
        });
    };
  };

  
export const registerPartner = () => {

  return async (dispatch, getState) => {
    const state = getState();
    const stepDataAll = state.partnerReducer.stepData;

    try {

      const formData = prepareFinalPartnerFormData(stepDataAll);

      const response = await axios({
        method: 'POST',
        url: `${config.API_URL}/company/startRegister`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json'
        }
      });

      const result = response.data;
      console.log('[enviarCadastroFinal] response:', result);

      // 🧠 Trata diferentes tipos de resposta
      if (result?.documentAlreadyUsed) {
        return {
          success: false,
          errorMessage: 'Já existe uma empresa com o CNPJ informado.'
        };
      }

      if (result?.contactAlreadyUsed) {
        return {
          success: false,
          errorMessage: result.emailAlreadyUsed && result.phoneAlreadyUsed
            ? 'Email e telefone já estão em uso.'
            : result.emailAlreadyUsed
              ? 'Email já está em uso.'
              : 'Telefone já está em uso.'
        };
      }

      if (!result?.success) {
        return {
          success: false,
          errorMessage: result?.errorMessage || 'Erro inesperado ao enviar cadastro.'
        };
      }

      // 🔐 Sucesso com token
      if (result?.token) {
        return {
          success: true,
          token: result.token,
        };
      }

      return {
        success: true
      };

    } catch (error) {
      console.error('[enviarCadastroFinal] erro:', error);
      return {
        success: false,
        errorMessage: error?.response?.data?.errorMessage || 'Falha na conexão ou erro inesperado.'
      };
    }
  };
};
  